import * as React from 'react';
import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import { StepIconProps } from '@mui/material/StepIcon';
import { Add, Check, EmojiEmotions, Grading, Science, Task } from '@mui/icons-material';
import { Typography } from '@mui/material';

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage:
        'linear-gradient( 95deg,#4EA72E 0%,#4EA72E 100%,white 100%)',
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage:
        'linear-gradient( 95deg,#4EA72E 0%,#4EA72E 100%,white 100%)',
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor:
      theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
    borderRadius: 1,
  },
}));

const ColorlibStepIconRoot = styled('div')<{
  ownerState: { completed?: boolean; active?: boolean };
}>(({ theme, ownerState }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#ccc',
  zIndex: 1,
  color: '#fff',
  width: 50,
  height: 50,
  display: 'flex',
  borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center',
  ...(ownerState.active && {
    backgroundImage:
      'linear-gradient( 136deg, #4EA72E 0%, #4EA72E 50%, #4EA72E 100%)',
    boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
  }),
  ...(ownerState.completed && {
    backgroundImage:
      'linear-gradient( 136deg, #4EA72E 0%, #4EA72E 50%, #4EA72E 100%)',
  }),
}));

function ColorlibStepIcon(props: StepIconProps) {
  const { active, completed, className } = props;

  const icons: { [index: string]: React.ReactElement } = {
    1: <Add />,
    2: <Grading />,
    3: <Science />,
    4: <Task />,
    5: <EmojiEmotions />,
    6: <Check />,
  };

  return (
    <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
      {icons[String(props.icon)]}
    </ColorlibStepIconRoot>
  );
}

const formatDate = (dateString: string) => {
  // Divide a string de data em partes
  const [ano, mes, dia] = dateString.split('-');
  
  // Formata a data com os valores obtidos
  return `${dia}/${mes}/${ano}`;
};

const steps = ['Solicitada', 'Em aprovação', 'Em análise', 'Relatório', 'Pesquisa de satisfação', 'Concluída'];

export default function CustomizedSteppers({ activeStep, dataSolicitacao, dataAceite, dataRelatorio, dataPesquisa, dataFinalizado }: any) {
  return (
    <Stack sx={{ width: '100%' }} spacing={4}>
      <Stepper alternativeLabel activeStep={activeStep} connector={<ColorlibConnector />}>
        {steps.map((label, index) => {
          const date = 
            index === 0 ? dataSolicitacao :
            index === 1 ? dataSolicitacao :
            index === 2 ? dataAceite :
            index === 3 ? dataRelatorio :
            index === 4 ? dataPesquisa :
            index === 5 ? dataFinalizado :
            null;

          return (
            <Step key={label}>
              <StepLabel 
                StepIconComponent={ColorlibStepIcon}
                optional={date ? (
                  <Typography variant='body2'>{formatDate(date)}</Typography>
                ) : null}
              >
                {label}
              </StepLabel>
            </Step>
          );
        })}
      </Stepper>
    </Stack>
  );
}